import { get } from 'lodash';
import { useTranslation } from 'react-i18next';

import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';

// Max length supported by USD (addressAttention field)
const CONTACT_NAME_MAX_LENGTH = 35;

interface IProps {
  nameMaxLength?: number;
}

export const ContactFormFields = ({ nameMaxLength = CONTACT_NAME_MAX_LENGTH }: IProps) => {
  const { t } = useTranslation();

  const { control, errors } = useFormContext();

  return (
    <>
      <FormField
        name="contactName"
        type={InputType.TEXT_INPUT}
        inputProps={{
          control,
          error: get(errors, 'contactName'),
          placeholder: t('labelName'),
          label: t('labelName'),
          slotProps: {
            input: {
              maxLength: nameMaxLength,
            },
          },
        }}
      />
      <FormField
        name="contactPhone"
        type={InputType.TEXT_INPUT}
        inputProps={{
          control,
          error: get(errors, 'contactPhone'),
          placeholder: t('labelPhone'),
          label: t('labelPhone'),
        }}
      />
      <FormField
        name="contactEmail"
        type={InputType.TEXT_INPUT}
        inputProps={{
          control,
          error: get(errors, 'contactEmail'),
          placeholder: t('labelEmail'),
          label: t('labelEmail'),
        }}
      />
      <FormField
        name="contactCompanyName"
        type={InputType.TEXT_INPUT}
        inputProps={{
          control,
          error: get(errors, 'contactCompanyName'),
          placeholder: t('labelCompanyName'),
          label: t('labelCompanyName'),
        }}
      />
    </>
  );
};
